import BaseValidator from 'services/validations/base-validator';
import {groupObjectsByProp} from 'helpers/array-helper';

export default class MinGamesValidator extends BaseValidator {
    private minGames: number = 0;

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.minGames = sportConfig.getConfigProp('minGames', 0);

        if (this.isGamesQuantityInsufficient()) {
            this.addError(`The min games is ${this.minGames}.`);
        }
    }

    private isGamesQuantityInsufficient(): boolean {
        const gamesQuantity = this.calcGamesQuantityInEditedLineup();

        return gamesQuantity < this.minGames;
    }

    private calcGamesQuantityInEditedLineup(): number {
        // @ts-ignore
        const {lineupPlayers} = this.dependencies;

        const games = groupObjectsByProp(lineupPlayers, 'gameInfo');

        return Object.keys(games).length;
    }
}
